import { LoadScriptProps } from '@react-google-maps/api';

export const loadScriptProps: LoadScriptProps = {
  googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || '',
  language: 'en',
  region: 'us',
  libraries: ['places'],
  id: 'script-loader',
};
